import React, {useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import Layout from '../../../components/layout/Layout';
import {useLocation} from "react-router-dom";
import * as Icon from "ubs-icons";
import {isMobileDevice} from "../../../common/functions";
import UInput from "../../../common/component/UInput";
import Validator from "simple-react-validator"
import {useForceUpdate} from "../../common/useForceUpdate";
import UPopup from "../../../common/component/UPopup";
import {COLOR} from "../../../common/constant";
import {detectDevice, showToastSuccess} from 'ubs-framework/v2/common/function';
import OtpInput from "react-otp-input";
import {withRouter} from "../../../common/hocs/routing-hoc";
import axios from 'axios';
import Skeleton from 'ubs-framework/src/skeleton';
import {useUAlert} from "ubs-framework";


let interval = null
const OTP_TIMEOUT = 5;

function useQuery() {
    const query = new URLSearchParams(useLocation().search);
    const queryParams = {};
    query.forEach((value, key) => {
      queryParams[key] = value;
    });
    return queryParams;
  }

function Authorize(props) {
    const alert = useUAlert();
    const params = useQuery();
    const dispatch = useDispatch();
    const CloseModal = useRef("u_select-place");
    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: {forceUpdate}
    }));

    const [errorMsg, setErrorMsg] = useState("");
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [loginDetail, setLoginDetail] = useState({
        identifier: "",
        password: "",
        platform: detectDevice(true),
    })
    const [hide, setHide] = useState(false)
    const [appDetails, setAppDetails] = useState({});
    const [showOTP, setShowOTP] = useState(false);
    const [otp, setOTP] = useState('');
    const [seconds, setSeconds] = useState(0);

    const onSubmit = (data) => {
        data.preventDefault()
        if (validator?.current?.allValid()) {
            setDisabledBtn(true)
            dispatch({type: 'SET_EMAIL', payload: data});
            if(params?.client_id) {
                const data = {
                    ...loginDetail,
                    email: loginDetail?.identifier
                }
                if (showOTP) data.otp = otp
                
                axios.post(`${process.env.REACT_APP_ACCOUNT_SOCKET_URL}/oauth2/login${window.location.search}`, data).then(res => {
                    if(!!res?.data?.data?.isMultiFactorAuth) {
                        setShowOTP(true)
                        setDisabledBtn(false)
                        setSeconds(OTP_TIMEOUT)
                    } else {
                        if(res?.data?.data?.redirect_uri) {
                            window.location.href = res?.data?.data?.redirect_uri
                        }
                    }  
                }).catch(err => {
                    setDisabledBtn(false)
                    alert.show({title: 'Oops...', description: err?.response?.data?.err || err?.response?.data?.message})
                    // setErrorMsg(err?.response?.data?.err || "Something went wrong.")
                })
            }
        } else {
            validator?.current?.showMessages()
        }
    }

    const resendOTP = (data) => {
        data.preventDefault()
        if (validator?.current?.fieldValid('identifier') && validator?.current?.fieldValid('password')) {
            setDisabledBtn(true)
            if(params?.client_id) {
                const data = {
                    ...loginDetail,
                    email: loginDetail?.identifier
                }
                axios.post(`${process.env.REACT_APP_ACCOUNT_SOCKET_URL}/oauth2/login${window.location.search}`, data).then(res => {
                    setShowOTP(true)
                    setDisabledBtn(false)
                    setSeconds(OTP_TIMEOUT)
                    showToastSuccess("OTP sent successfully.")
                })
            } 
        } else {
            validator?.current?.showMessages()
        }
    }

    const inputEvent = (e) => {
        let {name, value} = e.target;
        value = value.replace(/^\s+/g, '').trim()
        setLoginDetail((val) => {
            return {...val, [name]: value}
        })
    }
    const onKeyUp = e => {
        if (e.key === "Enter") onSubmit(e)
    }

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if(params?.client_id && params?.orgId) {
            axios.get(`${process.env.REACT_APP_ACCOUNT_SOCKET_URL}/oauth2/app-info${window.location.search}`).then(res => {
                setAppDetails(res?.data?.data)
            })
        }

        document?.getElementsByClassName("u_account-form").autofocus;
    }, [])

    useEffect(() => {
        if (seconds === OTP_TIMEOUT) {
            clearInterval(interval)
            interval = setInterval(() => {
                setSeconds(prevState => {
                    if (prevState === 1) {
                        clearInterval(interval)
                        return 0
                    } else return prevState - 1
                })
            }, 1000)
        }
    }, [seconds]);


    return (
        <React.Fragment>
            <Layout module="authorize">
                <div className="u_account-form" ref={CloseModal}>
                    <div className="u_mb-20 u_flex u_justify-center" style={{width: "96px", height: "96px"}}>
                        {appDetails?.client_logo ? (
                            <img src={appDetails.client_logo} alt="app-logo" style={{width: "100%", height: "100%"}}/>
                        ) : (
                            <Skeleton width="96px" height="96px" rounded/>
                        )}
                    </div>
                    <div className={`u_section-header`}>
                        <div className="u_border-header u_border-header-center">
                            <h1>{appDetails?.client_name ? (
                                `Authorize ${appDetails?.client_name}`
                            ) : (
                                <Skeleton width="200px" height="32px" />
                            )}</h1>
                        </div>
                        <p>
                            {appDetails?.client_name ? (
                                `Please Sign In to access ${appDetails?.client_name}.`
                            ) : (
                                <Skeleton width="300px" height="24px" />
                            )}
                        </p>
                    </div>
                    <UInput hasError={validator?.current?.message("identifier", loginDetail?.identifier, "required")}
                            className="u_mb-20" label="Email Address / User Name" asterisk>
                        <input onChange={inputEvent} value={loginDetail.identifier} type="text" onKeyUp={onKeyUp}
                               name="identifier" placeholder=" "/>
                    </UInput>
                    <UInput className="u_mb-20" password label="Password" asterisk
                            hasError={validator?.current?.message("password", loginDetail?.password, "required|min:8")}>
                        <input onChange={inputEvent} value={loginDetail.password}
                               type={`${hide ? "text" : "password"}`}
                               autoComplete="off"
                               onKeyUp={onKeyUp}
                               name="password"
                               placeholder=" "/>
                        <div className="u_input-note u_ib">
                            <UPopup params={{className: "u_tooltip u_tooltip-full", disabled: isMobileDevice()}}
                                    desc={<span>{!hide ? "Show Password" : "Hide Password"} </span>}>

                                <span className="u_rollover u_cp u_flex" onClick={() => setHide(!hide)}>{!hide ?
                                    <Icon.HideEye size={18} fill={COLOR.u_icon_bg}/> :
                                    <Icon.Eye size={18} fill={COLOR.u_icon_bg}/>}</span>
                            </UPopup>
                        </div>
                    </UInput>
                    {showOTP && <div className={`u_otp ${errorMsg ? 'u_mb-15' : 'u_mb-30'}`}>
                        <p className="u_mb-15 u_section-text">A six-digit OTP has been sent to your work email for verification.</p>
                        <OtpInput
                            value={otp}
                            onChange={(e) => setOTP(e)}
                            isInputNum={true}
                            containerStyle={'u_otp-container'}
                            inputStyle={'u_otp-input'}
                            numInputs={6}
                            shouldAutoFocus={true}
                            separator={<span> </span>}
                        />
                        <p className="u_mt-10 u_section-text">Didn't you receive the OTP? {seconds === 0 ?
                            <span className="u_cp u_blue" onClick={e => resendOTP(e, true)}>Resend OTP</span> : `${seconds} Seconds`}</p>
                    </div>}
                    {errorMsg.length !== 0 && <p className="u_error-message u_mb-15">{errorMsg}</p>}
                    {showOTP && <p className="u_error-message u_mb-15">{validator?.current?.message("otp", otp, "required|min:6")}</p>}
                    
                    <div className="u_block u_relative">
                        <button disabled={disabledBtn} type="button" onClick={onSubmit} className={`u_account-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}>Login</button>
                        {disabledBtn && <div className="u_btn-loader"><Icon.Preloader size={70}/></div>}
                    </div>
                </div>
            </Layout>
        </React.Fragment>
    );
}

export default withRouter(Authorize);
